var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "url(#pattern0_495_1478)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_495_1478",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_495_1478",
    transform: "scale(0.0416667)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_495_1478",
    width: 24,
    height: 24,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAa1JREFUSEvF1b2PTVEUBfDfq31MMRj9jE5EMRKFRAZDNdUUolNpdSoaIRKJv0CilGlGIwrxEUyCUGlUajGhEVQS3C37Jec+971778tLnOpk55y19l57n3UGZrcGOIjP+DSEjeAs1g7cx0qCXcfl2JcE+3ETp7EwgfVZARTHduIpjozcuYJrJcEGznYo5zFW81yAP8JRvM77IdMD/MSukuAL5nEcLzoQjYJH5d+wiA95f19J8DuDXfpSgr/CmQQv4/ewPg3BbjxMWQI8Mv+evSjlOoUffQkC/DkO420l5YkCfNjoMl6bojaJeoOPjukkgnHgEY+pihGtZd700MYRTAJvkqs2gF16sFVleaxq5suclmhokD7BchUrGx3gQfpr+BjbCA7hXXrLgWzoXMoS4CXpMPOaEm0E8dyv4jYuZOZtsvQieJMNvIOvWMPSmMynqiBAQ+9ybeJ8ytXkKL0quIgbeI8ww7uVVB9bfKoXQQfP++fI/yOIr25PD7tuqu5kjnBY/95Rq+j64XSRLbDONX2Zt/K3+ss+xdpOK7+E2NfcdAq89itdfq92lAkn/gBUCnU1ZqLfegAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit_icon.7c22d807d86df68d2fa2a8e719898b0b.svg";
export { ForwardRef as ReactComponent };